import React, { useEffect, useRef, useState } from "react";
import { MCard } from "components/Shared";
import MGrid, { ACTION_DOWNLOAD, COL_CODE_FULL_NAME, COL_CODE_POLICY_NUMBER, COL_CODE_SURVEY_TYPE } from "components/Shared/MGrid";
import { RelatedCaseResponse } from "interfaces/Mueller.Business.Models";
import { getRelatedCases } from "requests/caseLinks";
import { COL_CODE_CONTROL_NUMBER, COL_CODE_DATE } from "components/Shared/MGrid";


interface Props {
  controlNumber: number,
};

const RelatedCases = ({ controlNumber }: Props) => {
  const [relatedCaseList, setRelatedCaseList] = useState<RelatedCaseResponse[]>(null);
  const mounted = useRef(true);

  
  const setRelatedCaseListWrapped = (caseList: RelatedCaseResponse[]) => {
    // business rule here is the request that if the only case coming back is our control number, we want an empty list
    // otherwise, we still want our same case to show up in the list
    if (caseList.length === 1 && caseList[0].controlIdNumber === controlNumber) {
      setRelatedCaseList([]);
    } else {
      setRelatedCaseList(caseList);
    }
  };

  useEffect(() => {
    getRelatedCases(controlNumber, setRelatedCaseListWrapped, mounted);
  }, []);

  return (
      <MCard title="Related Cases">
        <div style={{height: "320px"}}>
          { relatedCaseList?.length === 0 ?
              "No related cases found"
              :
              <MGrid
                data={relatedCaseList}
                actions={[{ code: ACTION_DOWNLOAD }]}
                downloadFileName={`Cases Related to ${controlNumber}`}
                columnDefinitions={[
                  { code: COL_CODE_CONTROL_NUMBER, dataSource: "controlIdNumber" },
                  { code: COL_CODE_SURVEY_TYPE, dataSource: "surveyType" },
                  { code: COL_CODE_POLICY_NUMBER, name: "Policy Number", dataSource: "policyNumber" },
                  { code: COL_CODE_FULL_NAME, key: "policyHolderName", name: "Policy Holder Name", dataSource: "policyHolderName" },
                  { key: "inspectionAddress", name: "Inspection Address", width: 200, dataSource: (col: RelatedCaseResponse) => `${col.inspectionAddress.address1} ${col.inspectionAddress.city}, ${col.inspectionAddress.state} ${col.inspectionAddress.zip}` },
                  { code: COL_CODE_FULL_NAME, key: "frAssigned", name: "FR Assigned", dataSource: "inspectorAssigned" },
                  { key: "status", name: "Status", width: 120, dataSource: "insuranceStatus" },
                  { code: COL_CODE_DATE, key: "apptDate", name: "Appointment Date", width: 140, dataSource: "fieldAppointmentDate" },
                ]}
              />
          }
        </div>
      </MCard>
  );

};

export default RelatedCases;
